import { PaletteOptions, PaletteColorOptions } from '@mui/material'

declare module '@mui/material/styles' {
  interface SimplePaletteColorOptions {
    25?: string
    950?: string
    '100%'?: string
    '87%'?: string
    '72%'?: string
    '52%'?: string

    '32%'?: string
    '24%'?: string
    '16%'?: string
    '12%'?: string
    '6%'?: string
    '4%'?: string
    '2%'?: string

    '0.1%'?: string

    '500-24%'?: string
    '500-16%'?: string
    '500-12%'?: string
    '500-6%'?: string
    '500-4%'?: string

    '600-6%'?: string
    '600-32%'?: string
  }

  interface Palette {
    brand: PaletteColor
    black: PaletteColor

    white: PaletteColor
    gray: PaletteColor
    grey: PaletteColor
    red: PaletteColor
    pink: PaletteColor

    cyan: PaletteColor
    orange: PaletteColor

    yellow: PaletteColor

    green: PaletteColor

    blue: PaletteColor

    purple: PaletteColor
  }

  interface PaletteOptions {
    brand: PaletteColorOptions
    black: PaletteColorOptions

    white: PaletteColorOptions
    gray: PaletteColorOptions
    grey: PaletteColorOptions
    red: PaletteColorOptions
    pink: PaletteColorOptions

    cyan: PaletteColorOptions
    orange: PaletteColorOptions

    yellow: PaletteColorOptions

    green: PaletteColorOptions

    blue: PaletteColorOptions

    purple: PaletteColorOptions
  }

  interface PaletteColor {
    50: string
    100: string
    200: string
    300: string
    400: string
    500: string
    600: string
    700: string
    800: string
    900: string
    950: string
    '100%'?: string
    '87%'?: string
    '72%'?: string
    '52%'?: string
    '32%'?: string
    '24%'?: string
    '16%'?: string
    '12%'?: string
    '6%'?: string
    '4%'?: string
    '2%'?: string

    '0.1%'?: string

    '500-24%'?: string
    '500-16%'?: string
    '500-12%'?: string
    '500-6%'?: string
    '500-4%'?: string

    '600-6%'?: string
    '600-32%'?: string
  }
}

export const palette: PaletteOptions = {
  primary: {
    50: '#f6f6f6',
    100: '#e7e7e7',
    200: '#d1d1d1',
    300: '#b0b0b0',
    400: '#888888',
    500: '#6d6d6d',
    600: '#5d5d5d',
    700: '#4f4f4f',
    800: '#454545',
    900: '#3d3d3d',
    950: '#000000',
  },
  brand: {
    50: '#F6F4FE',
    100: '#EEEBFC',
    200: '#DFD9FB',
    300: '#C7BBF7',
    400: '#AA94F1',
    500: '#8F68EA',
    600: '#7F48DF',
    700: '#6F36CB',
    800: '#5D2DAA',
    900: '#4D278B',
    950: '#341967',
    '600-6%': 'hsla(262, 70%, 58%, 0.06)',
    '600-32%': 'hsla(262, 70%, 58%, 0.32)',
  },
  black: {
    '100%': 'hsla(0, 0%, 0%, 1)',
    '87%': 'hsla(0, 0%, 0%, 0.87)',
    '72%': 'hsla(0, 0%, 0%, 0.72)',
    '52%': 'hsla(0, 0%, 0%, 0.52)',
    '32%': 'hsla(0, 0%, 0%, 0.32)',
    '24%': 'hsla(0, 0%, 0%, 0.24)',
    '16%': 'hsla(0, 0%, 0%, 0.16)',
    '12%': 'hsla(0, 0%, 0%, 0.12)',
    '6%': 'hsla(0, 0%, 0%, 0.06)',
    '4%': 'hsla(0, 0%, 0%, 0.04)',
    '2%': 'hsla(0, 0%, 0%, 0.02)',
    main: '',
  },
  white: {
    100: '#FFFFFF',
    '100%': 'hsla(0, 0%, 100%, 1)',
    '87%': 'hsla(0, 0%, 100%, 0.87)',
    '72%': 'hsla(0, 0%, 100%, 0.72)',
    '52%': 'hsla(0, 0%, 100%, 0.52)',
    '32%': 'hsla(0, 0%, 100%, 0.32)',
    '24%': 'hsla(0, 0%, 100%, 0.24)',
    '16%': 'hsla(0, 0%, 100%, 0.16)',
    '12%': 'hsla(0, 0%, 100%, 0.12)',
    '6%': 'hsla(0, 0%, 100%, 0.06)',
    '4%': 'hsla(0, 0%, 100%, 0.04)',
    '2%': 'hsla(0, 0%, 100%, 0.02)',
    '0.1%': 'hsla(0, 0%, 100%, 0.001)',
    main: '',
  },
  gray: {
    25: 'hsla(180, 9%, 98%, 1)',
    50: 'hsla(180, 5%, 96%, 1)',
    100: 'hsla(200, 6%, 90%, 1)',
    200: 'hsla(216, 5%, 82%, 1)',
    300: 'hsla(218, 5%, 69%, 1)',
    400: 'hsla(220, 5%, 53%, 1)',
    500: 'hsla(218, 5%, 40%, 1)',
    600: 'hsla(222, 5%, 36%, 1)',
    700: 'hsla(225, 5%, 31%, 1)',
    800: 'hsla(230, 4%, 27%, 1)',
    900: 'hsla(228, 4%, 24%, 1)',
    950: 'hsla(225, 5%, 15%, 1)',
  },
  grey: {
    25: 'hsla(180, 9%, 98%, 1)',
    50: 'hsla(180, 5%, 96%, 1)',
    100: 'hsla(200, 6%, 90%, 1)',
    200: 'hsla(216, 5%, 82%, 1)',
    300: 'hsla(218, 5%, 69%, 1)',
    400: 'hsla(220, 5%, 53%, 1)',
    500: 'hsla(218, 5%, 40%, 1)',
    600: 'hsla(222, 5%, 36%, 1)',
    700: 'hsla(225, 5%, 31%, 1)',
    800: 'hsla(230, 4%, 27%, 1)',
    900: 'hsla(228, 4%, 24%, 1)',
    950: 'hsla(225, 5%, 15%, 1)',
  },
  red: {
    25: 'hsla(0, 86%, 97%, 1)',
    100: 'hsla(0, 93%, 94%, 1)',
    200: 'hsla(0, 96%, 89%, 1)',
    300: 'hsla(0, 94%, 82%, 1)',
    400: 'hsla(0, 91%, 71%, 1)',
    500: 'hsla(0, 84%, 60%, 1)',
    '500-24%': 'hsla(0, 84%, 60%, 0.24)',
    '500-16%': 'hsla(0, 84%, 60%, 0.16)',
    '500-12%': 'hsla(0, 84%, 60%, 0.12)',
    '500-6%': 'hsla(0, 84%, 60%, 0.06)',
    '500-4%': 'hsla(0, 84%, 60%, 0.04)',
    600: 'hsla(0, 72%, 51%, 1)',
    700: 'hsla(0, 74%, 42%, 1)',
    800: 'hsla(0, 70%, 35%, 1)',
    900: 'hsla(0, 75%, 15%, 1)',
  },
  pink: {
    50: 'hsla(333, 73%, 97%, 1)',
    100: 'hsla(331, 78%, 95%, 1)',
    200: 'hsla(330, 85%, 90%, 1)',
    300: 'hsla(330, 87%, 82%, 1)',
    400: 'hsla(330, 86%, 70%, 1)',
    500: 'hsla(330, 81%, 60%, 1)',
    600: 'hsla(330, 71%, 51%, 1)',
    700: 'hsla(330, 78%, 42%, 1)',
    800: 'hsla(330, 74%, 35%, 1)',
    900: 'hsla(330, 69%, 30%, 1)',
    950: 'hsla(330, 84%, 17%, 1)',
  },
  orange: {
    50: 'hsla(23, 100%, 96%, 1)',
    100: 'hsla(24, 100%, 92%, 1)',
    200: 'hsla(24, 98%, 83%, 1)',
    300: 'hsla(25, 97%, 72%, 1)',
    400: 'hsla(25, 96%, 61%, 1)',
    500: 'hsla(25, 95%, 53%, 1)',
    600: 'hsla(25, 90%, 48%, 1)',
    700: 'hsla(25, 88%, 40%, 1)',
    800: 'hsla(25, 79%, 34%, 1)',
    900: 'hsla(24, 75%, 28%, 1)',
    950: 'hsla(25, 81%, 15%, 1)',
  },
  yellow: {
    50: 'hsla(46, 92%, 95%, 1)',
    100: 'hsla(46, 97%, 88%, 1)',
    200: 'hsla(46, 98%, 77%, 1)',
    300: 'hsla(45, 98%, 64%, 1)',
    400: 'hsla(45, 96%, 53%, 1)',
    500: 'hsla(45, 93%, 47%, 1)',
    600: 'hsla(45, 96%, 40%, 1)',
    700: 'hsla(46, 92%, 33%, 1)',
    800: 'hsla(45, 81%, 29%, 1)',
    900: 'hsla(45, 73%, 26%, 1)',
    950: 'hsla(45, 83%, 14%, 1)',
  },
  green: {
    50: 'hsla(143, 76%, 97%, 1)',
    100: 'hsla(143, 84%, 93%, 1)',
    200: 'hsla(142, 79%, 85%, 1)',
    300: 'hsla(142, 77%, 73%, 1)',
    400: 'hsla(142, 69%, 58%, 1)',
    500: 'hsla(142, 71%, 45%, 1)',
    600: 'hsla(142, 76%, 36%, 1)',
    700: 'hsla(142, 72%, 29%, 1)',
    800: 'hsla(142, 64%, 24%, 1)',
    900: 'hsla(142, 61%, 20%, 1)',
    950: 'hsla(142, 80%, 10%, 1)',
  },
  blue: {
    50: 'hsla(218, 100%, 97%, 1)',
    100: 'hsla(218, 95%, 93%, 1)',
    200: 'hsla(217, 97%, 87%, 1)',
    300: 'hsla(217, 96%, 78%, 1)',
    400: 'hsla(217, 94%, 68%, 1)',
    500: 'hsla(217, 91%, 60%, 1)',
    600: 'hsla(217, 83%, 53%, 1)',
    700: 'hsla(217, 76%, 48%, 1)',
    800: 'hsla(217, 71%, 40%, 1)',
    900: 'hsla(217, 64%, 33%, 1)',
    950: 'hsla(217, 57%, 21%, 1)',
  },
  cyan: {
    50: 'hsla(189, 100%, 96%, 1)',
    100: 'hsla(189, 96%, 90%, 1)',
    200: 'hsla(189, 94%, 82%, 1)',
    300: 'hsla(189, 92%, 69%, 1)',
    400: 'hsla(189, 86%, 53%, 1)',
    500: 'hsla(189, 94%, 43%, 1)',
    600: 'hsla(189, 91%, 36%, 1)',
    700: 'hsla(189, 82%, 31%, 1)',
    800: 'hsla(189, 70%, 27%, 1)',
    900: 'hsla(189, 64%, 24%, 1)',
    950: 'hsla(191, 57%, 21%, 1)',
  },
  purple: {
    50: 'hsla(270, 100%, 98%, 1)',
    100: 'hsla(271, 100%, 95%, 1)',
    200: 'hsla(271, 100%, 92%, 1)',
    300: 'hsla(271, 97%, 85%, 1)',
    400: 'hsla(271, 95%, 75%, 1)',
    500: 'hsla(271, 91%, 65%, 1)',
    600: 'hsla(271, 81%, 56%, 1)',
    700: 'hsla(271, 72%, 47%, 1)',
    800: 'hsla(271, 67%, 39%, 1)',
    900: 'hsla(271, 66%, 32%, 1)',
    950: 'hsla(271, 87%, 21%, 1)',
  },
}
